import { render, staticRenderFns } from "./OverviewCourseLevel.vue?vue&type=template&id=146c1a56&scoped=true&"
import script from "./OverviewCourseLevel.vue?vue&type=script&lang=js&"
export * from "./OverviewCourseLevel.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCourseLevel.vue?vue&type=style&index=0&id=146c1a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c1a56",
  null
  
)

export default component.exports